#!/usr/bin/env node
import {
  AgentCredentialRevokedError,
  createCli,
  UpgradeRequiredError,
} from '@whittlelabs/shuttle';
import { sifterBrand } from './brand';

createCli(sifterBrand)
  .parseAsync(process.argv)
  .catch((err: unknown) => {
    if (err instanceof UpgradeRequiredError) {
      console.error('');
      console.error(`This ${sifterBrand.product.title} is too old.`);
      console.error('');
      console.error(`  Installed: ${err.currentVersion}`);
      console.error(`  Required:  ${err.minVersion} or newer`);
      console.error('');
      console.error(`Run: npm install -g ${err.packageName}@latest`);
      console.error('');
      process.exit(2);
    }
    if (err instanceof AgentCredentialRevokedError) {
      console.error('');
      console.error(`This ${sifterBrand.product.title}'s pairing has been revoked.`);
      console.error('');
      console.error('Keep refused its credentials — it was decommissioned from the');
      console.error('web app, or its secret was rotated by a newer pairing.');
      console.error('');
      console.error(`Run \`${sifterBrand.product.cliBinary} init\` to pair again.`);
      console.error('');
      process.exit(3);
    }
    const message = err instanceof Error ? err.message : String(err);
    console.error(`Fatal: ${message}`);
    process.exit(1);
  });
